module.exports = __webpack_public_path__ + "assets/images/ending5_adccf1cdbaab7cf3ffb616db1b23d09b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ending/ending5.png
// module id = 137
// module chunks = 0